// @ts-nocheck
import PropTypes from 'prop-types';
import React, { lazy, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Redirect,
  Route,
  Switch,
  HashRouter,
  useHistory,
  useLocation,
  BrowserRouter,
} from 'react-router-dom';
import { useTheme } from '@mui/material';
import UserConfirmationPrompt from '../components/Common/UserConfirmationPrompt';
import { CoreUtils } from '../utils/Utils';
import { AppConfig } from '../config/index';

import Login from '../pages/Login';
import Organization from '../pages/Organization';
import Layout from '../pages/Layout';
import PageNotFound from '../pages/PageNotFound';
import PageLevelLoader from '../components/Common/PageLevelLoader';

const PrivateRoute = ({ component: Component, isLoggedIn, loading, realm }) => (
  <Route
    render={(props) => {
      if (AppConfig.keycloakLogin === true && realm && loading) {
        return <PageLevelLoader />;
      }
      if (!isLoggedIn) {
        if (AppConfig.keycloakLogin === true && !realm) {
          return <Redirect to="/org" />;
        }
        return <Redirect to="/login" />;
      }
      return <Component {...props} loading={loading} />;
    }}
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  realm: PropTypes.string,
  loading: PropTypes.bool.isRequired,
};

PrivateRoute.defaultProps = {
  realm: null,
};

const PostLoginRedirect = ({ to, onDone }) => {
  const history = useHistory();

  useEffect(() => {
    if (to) {
      history.replace(to);
      onDone();
    }
  }, [to]);

  return null;
};

PostLoginRedirect.propTypes = {
  to: PropTypes.string,
  onDone: PropTypes.func.isRequired,
};

PostLoginRedirect.defaultProps = {
  to: null,
};

export const AppRoutes = ({
  loading,
  isLoggedIn,
  realm,
  landingRoute,
  onLandingRouteDone,
}) => {
  const { userConfirmationPrompt } = UserConfirmationPrompt(useTheme());

  return (
    <BrowserRouter>
      <PostLoginRedirect to={landingRoute} onDone={onLandingRouteDone} />
      <React.Suspense fallback={<PageLevelLoader />}>
        <Switch>
          {!isLoggedIn && AppConfig.keycloakLogin === true && (
            <Route path="/org" component={Organization} />
          )}
          {!isLoggedIn && AppConfig.keycloakLogin !== true && (
            <Route path="/login" component={Login} />
          )}

          <PrivateRoute
            path="/*"
            isLoggedIn={isLoggedIn}
            realm={realm}
            component={Layout}
            loading={loading}
          />
          <Route
            path="*"
            name="Not Found"
            render={(props) => <PageNotFound {...props} />}
          />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
};

AppRoutes.propTypes = {
  loading: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool,
  realm: PropTypes.string,
  landingRoute: PropTypes.string,
  onLandingRouteDone: PropTypes.func.isRequired,
};

AppRoutes.defaultProps = {
  isLoggedIn: false,
  realm: null,
  landingRoute: null,
};
